import _asyncToGenerator from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { networkConnection } from "./../connection/index";
import { useEffect } from 'react';
import { gnosisSafeConnection } from "../connection";
import { getConnection } from "../connection/utils";
import { useAppDispatch } from "../state/hooks";
import { updateSelectedConnectionType } from "../state/user/actions";
import { useSelectedConnectionType } from "../state/user/hooks";

var connect = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(connector) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            if (!connector.connectEagerly) {
              _context.next = 6;
              break;
            }

            _context.next = 4;
            return connector.connectEagerly();

          case 4:
            _context.next = 8;
            break;

          case 6:
            _context.next = 8;
            return connector.activate();

          case 8:
            _context.next = 13;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            console.warn('useEagerlyConnect: error', _context.t0);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 10]]);
  }));

  return function connect(_x) {
    return _ref.apply(this, arguments);
  };
}();

export var useEagerlyConnect = function useEagerlyConnect() {
  var dispatch = useAppDispatch();
  var selectedConnectionType = useSelectedConnectionType();
  var selectedConnection;

  if (selectedConnectionType) {
    try {
      selectedConnection = getConnection(selectedConnectionType);
    } catch (_unused) {
      dispatch(updateSelectedConnectionType(null));
    }
  }

  useEffect(function () {
    connect(gnosisSafeConnection.connector);
    connect(networkConnection.connector);

    if (selectedConnection) {
      connect(selectedConnection.connector);
    }
  }, []);
};